/**
 * Normalize HUD / Firestore challenge_type aliases to the canonical key
 * used by animation assets and presentation overrides.
 */
export function canonicalChallengeType(challengeType: string): string {
  const type = String(challengeType || '')
    .trim()
    .toLowerCase();
  if (type === 'pvp') {
    return 'competitive';
  }
  if (type === 'instant') {
    return 'luck';
  }
  if (type === 'endless') {
    return 'mastery';
  }
  return type;
}

/**
 * All type keys that may appear on DOM anchors / override maps for a challenge.
 * Includes the input value plus its canonical + alias pair.
 */
export function challengeTypeAliases(challengeType: string): string[] {
  const raw = String(challengeType || '').trim();
  const lower = raw.toLowerCase();
  const canonical = canonicalChallengeType(raw);

  const pairByCanonical: Record<string, string[]> = {
    competitive: ['competitive', 'pvp'],
    luck: ['luck', 'instant'],
    mastery: ['mastery', 'endless'],
  };

  const pair = pairByCanonical[canonical] ?? (canonical ? [canonical] : []);
  const keys = new Set<string>();
  if (raw) {
    keys.add(raw);
  }
  if (lower) {
    keys.add(lower);
  }
  for (const key of pair) {
    keys.add(key);
  }
  return [...keys];
}
